import intlTelInput from 'intl-tel-input';

export default class PhoneNumberPicker {
	private iti: intlTelInput;

	constructor(phoneInput: HTMLInputElement) {
		this.init(phoneInput);
	}

	private init(phone: HTMLInputElement) {
		this.iti = intlTelInput(phone, {
			initialCountry: "dk",
			preferredCountries: ["dk", "eg", "us", "gb"],
			utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js",
			formatOnDisplay: true,
		});
	}

	public isValidPhoneNumber(): boolean {
		return this.iti.isValidNumber();
	}

	public get phoneNumber(): string {
		return this.iti.getNumber();
	}

	public set phoneNumber(number: string) {
		this.iti.setNumber(number);
	}

	public onUtilsLoad(callback: () => void) {
		this.iti.promise.then(callback);
	}
}
